export enum  FieldTypeEnums {
    TEXT = "text",
    NUMERIC = "numeric",
    BOOLEAN = "boolean",
    LIST = "list"
  }
